import { Reveal } from "@/components/Reveal";

const PRESSURE_POINTS = [
  {
    title: "Production Risk",
    body: "Source impact, replication, performance, and cutover engineering.",
    testId: "pressure-production-risk",
  },
  {
    title: "Governance Risk",
    body: "Lineage, data contracts, access controls, auditability, and regulated-data patterns.",
    testId: "pressure-governance-risk",
  },
  {
    title: "Commercial Risk",
    body: "SKU mapping, technical validation, quantified business cases, and executive deal rooms.",
    testId: "pressure-commercial-risk",
  },
  {
    title: "AI Delivery Risk",
    body: "Governed data products, model readiness, data quality, and operating controls.",
    testId: "pressure-ai-delivery-risk",
  },
];

export default function ProofStandard() {
  return (
    <section
      id="proof-standard"
      data-testid="proof-standard-section"
      className="px-6 lg:px-12 py-24 lg:py-32 border-t border-white/10"
    >
      <div className="max-w-[1440px] mx-auto">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-white/50 mb-6">
            04 — The Proof Standard
          </p>
          <h2 className="font-serif tracking-tight text-4xl sm:text-5xl lg:text-6xl text-white max-w-4xl leading-[1.1]">
            We don&apos;t sell roadmap assurances.{" "}
            <span className="italic text-[#E6E4D9]">
              We build the evidence enterprise teams need to say yes.
            </span>
          </h2>
          <p className="mt-8 max-w-2xl text-base sm:text-lg font-light leading-relaxed text-white/60">
            Every engagement asset is built for technical validation: defined
            assumptions, architecture boundaries, measurable acceptance
            criteria, security and governance controls, operational runbooks,
            and a clear owner for every risk.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <p className="mt-16 lg:mt-20 font-mono text-xs uppercase tracking-[0.3em] text-white/50">
            Choose your pressure point
          </p>
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
            {PRESSURE_POINTS.map((point) => (
              <div
                key={point.title}
                data-testid={point.testId}
                className="group bg-[#0A0A0A] p-8 lg:p-10 hover:bg-[#101010] transition-colors duration-500"
              >
                <span className="block h-px w-8 bg-[#E6E4D9]/50 mb-6 transition-[width] duration-500 group-hover:w-14" />
                <h3 className="font-serif text-xl sm:text-2xl text-white tracking-tight mb-4">
                  {point.title}
                </h3>
                <p className="text-sm font-light leading-relaxed text-white/60">
                  {point.body}
                </p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
